export function slugify(inputStr: string) {
  // Remove diacritics
  inputStr = inputStr.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  inputStr = inputStr.toLowerCase();

  // Replace Norwegian characters
  inputStr = inputStr.replace(/ø/g, "o");
  inputStr = inputStr.replace(/æ/g, "ae");
  inputStr = inputStr.replace(/å/g, "a");

  // Replace any character that is not a lowercase letter or hyphen with a hyphen
  inputStr = inputStr.replace(/[^a-z0-9-]/g, "-");

  // Replace consecutive hyphens with a single one
  inputStr = inputStr.replace(/-+/g, "-");

  // Remove leading and trailing hyphens
  inputStr = inputStr.replace(/^-+|-+$/g, "");

  // If string is empty or consists only of hyphens, return the default slug
  if (!inputStr) {
    return "/";
  }

  return inputStr;
}
